import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";
import classNames from "classnames";

export default function InputSelect({
  children,
  popoverText,
  error,
  valid,
  errorMessage,
  ...params
}) {
  return (
    <>
      <Row className="align-items-center flex-nowrap position-relative mb-3">
        <Col xs={12} md={11} className="select_category">
          <Form.Select
            {...params}
            className={classNames("pe-5 pe-md-2 position-relative py-3", {
              "border-danger": error,
              "border-success": valid,
              "pb-2 pt-4": !!params.value,
              "text-gray": !params.value,
            })}
          >
            {children}
          </Form.Select>
          {!!params.value && (
            <small
              className="top-0 left-0 position-absolute m-2 ps-1 text-gray fs-7"
              style={{ opacity: 0.65 }}
            >
              {params?.defaultlabel}
            </small>
          )}
          {errorMessage}
        </Col>
        {popoverText !== null && (
          <div className="position-absolute top-0 end-0 mt-3 w-auto me-3">
            <PopoverBtn text={popoverText} />
          </div>
        )}
      </Row>
    </>
  );
}
